import { atomWithQuery } from "jotai-tanstack-query";
import { fetchMyVenues } from "../../apis/business";
import { syncUser } from "../../apis/auth";
import { Storage, atomWithLocalStorage } from "../../storage";

const MY_VENUES_PER_PAGE = 10_000;

export const authAtom = atomWithQuery(() => ({
  queryKey: ["userSync"],
  queryFn: async () => {
    const userString = Storage.getString("currentUser");
    const user = userString ? JSON.parse(userString) : null;
    if (!user) return null;
    const response = await syncUser(user.accessToken);
    if (response.status === "success") {
      return { ...response.data, accessToken: user.accessToken };
    } else {
      Storage.delete("currentUser");
      return null;
    }
  },
  // Force stale after 24 hours
  // staleTime: 1000 * 60 * 60 * 24,
  // staleTime: 0,  // Force immediate stale
}));

/** One shared query for all `useAuth()` consumers — avoids duplicate `fetchMyVenues` per mount. */
export const businessOwnedVenuesAtom = atomWithQuery((get) => {
  const authState = get(authAtom);
  const user = authState.data;
  const enabled = !!user?.accessToken && !!user?.roles?.isBusinessUser;

  return {
    queryKey: ["businessOwnedVenues", user?.accessToken],
    queryFn: async () => {
      return fetchMyVenues(user!.accessToken!, 1, MY_VENUES_PER_PAGE);
    },
    enabled,
  };
});

export const termsAndConditionsAgreedLocallyAtom =
  atomWithLocalStorage<boolean>("termsAndConditionsAgreedLocally", false);

export const remindLocationAtom = atomWithLocalStorage<boolean>(
  "remindLocation",
  false,
);
